import {
  EntityPickerFieldExtension,
  EntityNamePickerFieldExtension,
  EntityTagsPickerFieldExtension,
  RepoUrlPickerFieldExtension,
  OwnerPickerFieldExtension,
  OwnedEntityPickerFieldExtension,
  MyGroupsPickerFieldExtension,
  MultiEntityPickerFieldExtension,
  RepoBranchPickerFieldExtension,
} from '@backstage/plugin-scaffolder';
import { FieldExtensionOptions } from '@backstage/plugin-scaffolder-react';

export const defaultExtensions: FieldExtensionOptions[] = [
  {
    component: EntityPickerFieldExtension,
    name: 'EntityPicker',
  },
  {
    component: EntityNamePickerFieldExtension,
    name: 'EntityNamePicker',
  },
  {
    component: EntityTagsPickerFieldExtension,
    name: 'EntityTagsPicker',
  },
  {
    component: RepoUrlPickerFieldExtension,
    name: 'RepoUrlPicker',
  },
  {
    component: OwnerPickerFieldExtension,
    name: 'OwnerPicker',
  },
  {
    component: OwnedEntityPickerFieldExtension,
    name: 'OwnedEntityPicker',
  },
  {
    component: MyGroupsPickerFieldExtension,
    name: 'MyGroupsPicker',
  },
  {
    component: MultiEntityPickerFieldExtension,
    name: 'MultiEntityPicker',
  },
  {
    component: RepoBranchPickerFieldExtension,
    name: 'RepoBranchPicker',
  },
];

